<template>
  <nav>
    <div class="logo pc">
      <router-link to="/"
        ><img
          v-motion-slide-top
          :delay="500"
          src="@/assets/images/logo.svg"
          alt=""
      /></router-link>
    </div>
    <div class="logo mobile">
      <router-link to="/"
        ><img
          v-motion-slide-top
          :delay="500"
          src="@/assets/images/logoLong.svg"
          alt=""
      /></router-link>
    </div>
    <div v-motion-slide-top :delay="500" class="mobile hamburger-dropdown">
      <div
        @click="toggleOpen"
        :class="{ opened: isActive }"
        class="hamburger-lines"
      >
        <span class="line line1"></span>
        <span class="line line2"></span>
        <span class="line line3"></span>
      </div>
    </div>
    <div class="navigation pc">
      <div class="pc">
        <ul>
          <li v-motion-pop><router-link to="/">Úvod</router-link></li>
          <li v-motion-pop :delay="100">
            <router-link to="/Sluzby">Služby</router-link>
          </li>
          <li v-motion-pop :delay="200">
            <router-link to="/Cennik">Cenník</router-link>
          </li>
          <li v-motion-pop :delay="300">
            <router-link to="/Galeria">Galéria</router-link>
          </li>
          <li v-motion-pop :delay="400">
            <router-link to="/Kontakt">Kontakt</router-link>
          </li>
        </ul>
      </div>
    </div>

    <div class="phone">
      <a href="tel:+421904157144"
        ><img src="@/assets/icons/telephone.svg" alt=""
      /></a>
    </div>
  </nav>

  <div class="mobile">
    <div :class="{ opened: isActive }" class="pc menu mobile-navigation">
      <ul>
        <li @click="toggleOpen">
          <router-link to="/">Úvod</router-link>
        </li>
        <li @click="toggleOpen">
          <router-link to="/Sluzby">Služby</router-link>
        </li>
        <li @click="toggleOpen">
          <router-link to="/Cennik">Cenník</router-link>
        </li>
        <li @click="toggleOpen">
          <router-link to="/Galeria">Galéria</router-link>
        </li>
        <li @click="toggleOpen">
          <router-link to="/Kontakt">Kontakt</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: false,
    };
  },

  methods: {
    toggleOpen: function () {
      this.isActive = !this.isActive;
      // some code to filter users
    },
  },
};
</script>

<style lang="scss" scoped>
// IMPORT COLORS
@import "@/assets/sass/_colors.scss";

nav,
.mobile-navigation {
  background: rgba(darken($bg-clr, 3%), 0.45);
  padding: 0.5em 2%;
  z-index: 100;
  width: 96%;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position: fixed;

  .logo {
    width: 20%;
    display: flex;
    align-items: center;

    a img {
      width: 90%;
    }
  }

  .navigation {
    width: 80%;
  }

  ul {
    display: flex;
    flex-direction: row;
    justify-content: center;
    list-style: none;
    gap: 3.5%;
    font-size: 0.95em;

    li a {
      text-decoration: none;
      color: $txt-clr;
      position: relative;

      &:hover {
        font-weight: 600;
      }
    }
  }
}

.mobile-navigation {
  width: 100%;
  margin-top: 4.5em;
  background: rgba(darken($bg-clr, 3%), 0.8);
  ul {
    display: flex;
    flex-direction: column;
    width: 80%;
    margin: 1em 10%;

    li {
      line-height: 2em;
      font-size: 1.15em;
    }
    li:not(:first-child) {
      border-top: $bg-clr 0.1em solid;
    }
  }

  .language {
    width: 100%;
    gap: 0.5em;
    justify-content: center;
  }
}
.router-link-active {
  font-weight: 600;
}

.navigation .router-link-active:after,
.mobile-navigation .router-link-active:after {
  content: "";
  position: absolute;
  width: 70%;
  display: block;
  height: 2px;
  background-color: darken($scnd-clr, 10%);
  bottom: -5px;
  animation: active 1s cubic-bezier(0, 0.52, 0.58, 1);
}

@keyframes active {
  from {
    width: 0%;
  }
  to {
    width: 70%;
  }
}

@media screen and (min-width: 800px) {
  .pc {
    display: block;
  }

  .mobile,
  .mobile.logo {
    display: none;
    position: relative;
  }
}

@media screen and (max-width: 800px) {
  nav {
    justify-content: space-between;
    flex-direction: row;
    padding: 0.6em 5%;
    width: 90%;
    .logo {
      width: 45%;
      justify-content: flex-start;

      a img {
        width: 90% !important;
      }
    }

    .hamburger-dropdown {
      justify-content: flex-end;
      width: auto;
      margin: 0 5% 0 auto;
      display: flex;
      cursor: pointer;
    }

    .navigation {
      justify-content: center;
      width: 100%;
      display: flex;
      font-size: 120%;
    }
  }
  .pc {
    display: none !important;
  }

  .mobile {
    display: flex;
    justify-content: flex-end;
  }

  .opened {
    display: flex !important;
  }
}

/* Lines hamburger */
.hamburger-lines {
  display: block;
  height: 26px;
  width: 32px;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.hamburger-lines .line {
  display: block;
  height: 4px;
  width: 100%;
  border-radius: 10px;
  background: darken($scnd-clr, 10%);
  transition: transform 0.4s ease-in-out;
}

.hamburger-lines .line1 {
  transform-origin: 0% 0%;
  transition: transform 0.4s ease-in-out;
}

.hamburger-lines .line2 {
  transition: transform 0.2s ease-in-out;
}

.opened.hamburger-lines .line3 {
  transform-origin: 0% 100%;
  transition: transform 0.4s ease-in-out;
}

.opened.hamburger-lines .line1 {
  transform: rotate(45deg);
}

.opened.hamburger-lines .line2 {
  transform: scaleY(0);
}

.opened.hamburger-lines .line3 {
  transform: rotate(-45deg);
}

//moje css pre bezkom.sk

nav {
  .logo {
    width: auto;

    a img {
      width: 2.7rem;
    }
  }

  .phone {
    width: auto;

    a img {
      width: 2.8rem;
    }
  }
}
</style>
